<div class="w-full flex flex-row items-start gap-x-4 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 p-2">
    <div class="shrink-0">
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m9 18 6-6-6-6" />
            </svg>
            }
        </button>
    </div>

    <!-- Collapsed Content -->
    @if (!expanded()) {
    <div (click)="expanded.set(!expanded())" class="flex-1 flex flex-col gap-y-2 hover:cursor-pointer">
        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Demographics
        </label>
        <ul role="list" class="flex flex-col gap-y-0 text-gray-600 dark:text-gray-400">
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Location: </p>
                <p class="text-sm text-secondary">{{ locationSummaryLabel() }}</p>
            </li>
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Age: </p>
                <p class="text-sm text-secondary">{{ ageSummaryLabel() }}</p>
            </li>
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Gender: </p>
                <p class="text-sm text-secondary">{{ genderSummaryLabel() }}</p>
            </li>
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Languages: </p>
                <p class="text-sm text-secondary">{{ languagesSummaryLabel() }}</p>
            </li>
        </ul>
    </div>
    }
    <!-- Collapsed Content - END -->

    <!-- Opened Content -->
    @if (expanded()) {
    <div class="flex-1 flex flex-col gap-y-2">

        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Demographics
        </label>

        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">


            <div class="sm:col-span-full flex flex-col gap-3">
                <div>
                    <p id="demographic-location-label"
                        class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                        Location</p>
                    <p id="demographic-location-hint" class="text-xs text-gray-500 dark:text-gray-400">Search and select
                        one or more regions. Region IDs are stored for your ad group.</p>
                </div>

                @if (createSparkCampaignService.adGroupLocations() === undefined) {
                <p class="text-sm text-gray-500 dark:text-gray-400" role="status">Loading regions…</p>
                } @else if ((createSparkCampaignService.adGroupLocations() ?? []).length === 0) {
                <p class="text-sm text-gray-500 dark:text-gray-400" role="status">No regions available for this
                    campaign.</p>
                } @else {
                <div class="grid grid-cols-2 gap-4">


                    <div class="mt-1 col-span-1 flex flex-col gap-3">
                        <div class="relative">
                            <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-4 text-gray-400" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                        d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                            <input type="search" id="demographic-location-search"
                                class="block w-full rounded-md border-0 bg-white py-2 pl-10 pr-3 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-teal-600 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:placeholder:text-gray-500 dark:focus:ring-teal-500"
                                placeholder="Enter your target location" autocomplete="off"
                                [value]="locationSearchQuery()" (input)="onLocationSearchInput($event)"
                                aria-labelledby="demographic-location-label"
                                aria-describedby="demographic-location-hint" />
                        </div>

                        <div class="max-h-72 overflow-y-auto rounded-lg bg-white py-1 shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-900/40 dark:ring-white/10"
                            role="tree" aria-label="Target regions">
                            @if (isLocationSearchActive()) {
                            @if (searchFlatMatches().length === 0) {
                            <p class="px-3 py-4 text-sm text-gray-500 dark:text-gray-400" role="status">No regions match
                                your search.</p>
                            } @else {
                            <p class="px-3 pt-2 text-xs text-gray-500 dark:text-gray-400">Search results (up to 300)</p>
                            @for (node of searchFlatMatches(); track node.location_id) {
                            <div [class]="locationRowClass(node)" [style.padding-left.px]="locationRowPaddingPx(0)"
                                role="treeitem">
                                <span class="size-6 shrink-0" aria-hidden="true"></span>
                                <input type="checkbox" [id]="'loc-search-' + node.location_id"
                                    [checked]="isLocationSelected(node.location_id)"
                                    (change)="onLocationCheckboxChange(node, $event)"
                                    class="h-4 w-4 shrink-0 rounded border-gray-300 accent-teal-600 focus:ring-teal-600 dark:border-white/20 dark:accent-teal-500 dark:focus:ring-teal-500" />
                                <label [for]="'loc-search-' + node.location_id"
                                    class="block min-w-0 flex-1 cursor-pointer truncate text-sm font-medium text-gray-900 dark:text-gray-100">{{
                                    locationNodeLabel(node) }}</label>
                                @if (node.level) {
                                <span class="shrink-0 text-xs capitalize text-gray-400 dark:text-gray-500">{{
                                    locationLevelHint(node.level) }}</span>
                                }
                            </div>
                            }
                            }
                            } @else {
                            @if (rootCountriesForUi().length === 0) {
                            <p class="px-3 py-4 text-sm text-gray-500 dark:text-gray-400" role="status">No country-level
                                regions to browse. Use search above, or verify region data includes countries with
                                sub-regions.</p>
                            } @else {
                            <div
                                class="location-tree-scroll overflow-y-auto rounded-lg bg-white shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-900/40 dark:ring-white/10">
                                @for (country of rootCountriesForUi(); track country.location_id) {
                                <div role="treeitem"
                                    [attr.aria-expanded]="nodeHasChildren(country) ? isCountryDetailActive(country) : null">
                                    <div [class]="countryBrowseRowClass(country)">
                                        @if (nodeHasChildren(country)) {
                                        <button type="button"
                                            class="flex size-6 shrink-0 items-center justify-center rounded text-gray-600 hover:bg-teal-100/80 dark:text-gray-300 dark:hover:bg-white/10"
                                            (click)="toggleCountryDetailPanel(country)"
                                            [attr.aria-expanded]="isCountryDetailActive(country)"
                                            [attr.aria-label]="isCountryDetailActive(country) ? 'Collapse sub-regions for ' + locationNodeLabel(country) : 'Expand sub-regions for ' + locationNodeLabel(country)">
                                            @if (isCountryDetailActive(country)) {
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                                class="size-4 text-gray-600 dark:text-gray-300" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                    d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            } @else {
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                                class="size-4 text-gray-600 dark:text-gray-300" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                    d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            }
                                        </button>
                                        } @else {
                                        <span class="size-6 shrink-0" aria-hidden="true"></span>
                                        }
                                        <input type="checkbox" [id]="'loc-' + country.location_id"
                                            [checked]="countryCheckboxChecked(country)"
                                            [locIndeterminate]="countryCheckboxIndeterminate(country)"
                                            (change)="onLocationCheckboxChange(country, $event)"
                                            class="h-4 w-4 shrink-0 rounded border-gray-300 accent-teal-600 focus:ring-teal-600 dark:border-white/20 dark:accent-teal-500 dark:focus:ring-teal-500" />
                                        <label [for]="'loc-' + country.location_id" [class]="countryLabelClass(country)">{{
                                            locationNodeLabel(country) }}</label>
                                        @if (country.level) {
                                        <span class="shrink-0 text-xs capitalize text-gray-400 dark:text-gray-500">{{
                                            locationLevelHint(country.level) }}</span>
                                        }
                                    </div>
                                    @if (nodeHasChildren(country) && isCountryDetailActive(country)) {
                                    <div
                                        class="ml-3 border-b border-l-2 border-gray-100 border-l-teal-300/90 bg-white py-1 pl-3 dark:border-b-white/10 dark:border-l-teal-600/55 dark:bg-gray-900/30">
                                        <ng-container [ngTemplateOutlet]="regionNestedGrouped"
                                            [ngTemplateOutletContext]="{ $implicit: country, depth: 1 }" />
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                            }
                        </div>


                    </div>


                    <!-- List of Selected Regions -->
                    <div class="mt-1 col-span-1 flex flex-col gap-3">
                        <div
                            class="rounded-lg border border-teal-200/80 bg-gray-50/80 p-3 shadow-sm dark:border-teal-800/50 dark:bg-white/5">
                            <div class="flex items-start justify-between gap-2">
                                <p class="text-sm font-semibold text-gray-900 dark:text-white">{{
                                    selectedRegionsHeading()
                                    }}
                                </p>
                                <div class="flex shrink-0 items-center gap-1">
                                    <button type="button"
                                        class="rounded p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 dark:hover:bg-white/10 dark:hover:text-white"
                                        (click)="clearAllLocations()" [attr.aria-label]="'Clear all selected regions'"
                                        [disabled]="createSparkCampaignService.location_ids().length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                            class="size-5" aria-hidden="true">
                                            <path
                                                d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                        </svg>
                                    </button>
                                    <button type="button"
                                        class="rounded p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 dark:hover:bg-white/10 dark:hover:text-white"
                                        (click)="toggleSelectedLocationsPanel()"
                                        [attr.aria-expanded]="selectedLocationsPanelOpen()"
                                        aria-controls="demographic-selected-chips">
                                        @if (selectedLocationsPanelOpen()) {
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                            class="size-5" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        } @else {
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                            class="size-5" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        }
                                    </button>
                                </div>
                            </div>
                            @if (selectedLocationsPanelOpen()) {
                            <div id="demographic-selected-chips" class="mt-3 flex flex-col gap-4">
                                @for (group of selectedLocationSummaryGroups(); track trackCountryGroup($index, group)) {
                                <div class="flex flex-col gap-2">
                                    <p class="text-xs font-semibold text-gray-600 dark:text-gray-300">{{
                                        group.countryHeading }}</p>
                                    <div class="flex flex-wrap gap-2">
                                        @for (chip of group.chips; track trackSummaryChip($index, chip)) {
                                        <span
                                            class="inline-flex max-w-full items-center gap-1 rounded-md bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm ring-1 ring-gray-200/90 dark:bg-white/10 dark:text-gray-200 dark:ring-white/15">
                                            <span class="min-w-0 truncate">{{ chip.displayLabel }}</span>
                                            <button type="button"
                                                class="shrink-0 rounded p-0.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-white/10 dark:hover:text-white"
                                                (click)="removeSummaryChip(chip)"
                                                [attr.aria-label]="'Remove ' + chip.displayLabel">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-3.5" aria-hidden="true">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                        </span>
                                        }
                                    </div>
                                </div>
                                }
                                @if (createSparkCampaignService.location_ids().length === 0) {
                                <p class="text-xs text-gray-500 dark:text-gray-400">No regions selected yet.</p>
                                }
                            </div>
                            }
                        </div>
                    </div>
                    <!-- List of Selected Regions - END -->
                </div>
                }
            </div>

            <ng-template #regionNestedGrouped let-parent let-depth="depth">
                @for (grp of groupChildrenByLevel(parent); track grp.levelKey) {
                <div class="border-b border-gray-100 pb-1 dark:border-white/5">
                    <button type="button"
                        class="flex w-full min-w-0 items-center gap-2 rounded-md py-2 pr-2 text-left text-xs font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
                        [style.padding-left.px]="groupHeaderPaddingPx(depth)"
                        [class]="levelAccordionClass(isLevelGroupExpanded(parent.location_id, grp.levelKey))"
                        (click)="toggleLevelGroup(parent.location_id, grp.levelKey)"
                        [attr.aria-expanded]="isLevelGroupExpanded(parent.location_id, grp.levelKey)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            class="size-4 shrink-0 text-gray-500 transition-transform duration-150 dark:text-gray-400"
                            [class.rotate-90]="isLevelGroupExpanded(parent.location_id, grp.levelKey)"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z"
                                clip-rule="evenodd" />
                        </svg>
                        <span class="min-w-0 truncate text-gray-800 dark:text-gray-100">{{ grp.title }}</span>
                        <span class="shrink-0 text-gray-400 dark:text-gray-500">({{ grp.items.length }})</span>
                    </button>
                    @if (isLevelGroupExpanded(parent.location_id, grp.levelKey)) {
                    @for (item of grp.items; track item.location_id) {
                    <div [class]="locationRowClass(item)" [style.padding-left.px]="itemRowPaddingPx(depth)"
                        role="treeitem" [attr.aria-expanded]="nodeHasChildren(item) ? isNodeExpanded(item) : null">
                        @if (nodeHasChildren(item)) {
                        <button type="button"
                            class="flex size-6 shrink-0 items-center justify-center rounded text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10"
                            (click)="toggleNodeExpanded(item.location_id)" [attr.aria-expanded]="isNodeExpanded(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-4 transition-transform duration-150"
                                [class.rotate-90]="isNodeExpanded(item)" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                        } @else {
                        <span class="size-6 shrink-0" aria-hidden="true"></span>
                        }
                        <input type="checkbox" [id]="'loc-' + item.location_id"
                            [checked]="isLocationSelected(item.location_id)"
                            (change)="onLocationCheckboxChange(item, $event)"
                            class="h-4 w-4 shrink-0 rounded border-gray-300 accent-teal-600 focus:ring-teal-600 dark:border-white/20 dark:accent-teal-500 dark:focus:ring-teal-500" />
                        <label [for]="'loc-' + item.location_id"
                            class="block min-w-0 flex-1 cursor-pointer truncate text-sm font-medium text-gray-900 dark:text-gray-100">{{
                            locationNodeLabel(item) }}</label>
                        @if (item.level) {
                        <span class="shrink-0 text-xs capitalize text-gray-400 dark:text-gray-500">{{
                            locationLevelHint(item.level) }}</span>
                        }
                    </div>
                    @if (nodeHasChildren(item) && isNodeExpanded(item)) {
                    <ng-container [ngTemplateOutlet]="regionNestedGrouped"
                        [ngTemplateOutletContext]="{ $implicit: item, depth: depth + 1 }" />
                    }
                    }
                    }
                </div>
                }
            </ng-template>


            <div class="sm:col-span-3">
                <p id="demographic-age-label" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                    Age
                    Range</p>
                <p id="demographic-age-hint" class="text-xs text-gray-500 dark:text-gray-400">Select one or more
                    ranges. At least one must stay selected.</p>
                <div class="mt-1 grid w-full min-w-0 grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5" role="group"
                    aria-labelledby="demographic-age-label" aria-describedby="demographic-age-hint">
                    @for (opt of ageOptions; track opt.value) {
                    <button type="button" [attr.aria-pressed]="isAgeSelected(opt.value)" (click)="toggleAge(opt.value)"
                        [class]="ageToggleClass(opt.value)">
                        {{ opt.label }}
                    </button>
                    }
                </div>
            </div>

            <div class="sm:col-span-3">
                <p id="demographic-gender-label" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                    Gender</p>
                <p id="demographic-age-hint" class="text-xs text-gray-500 dark:text-gray-400">Select a gender or
                    "All".
                </p>
                <div class="mt-1 isolate flex w-full min-w-0 rounded-md shadow-xs dark:shadow-none" role="radiogroup"
                    aria-labelledby="demographic-gender-label">
                    @for (opt of genderOptions; track opt.value) {
                    <button type="button" role="radio" [attr.aria-checked]="isGenderSelected(opt.value)"
                        (click)="selectGender(opt.value)" [class]="genderSegmentClass(opt.value, $index)">
                        {{ opt.label }}
                    </button>
                    }
                </div>
            </div>

            <div class="sm:col-span-full flex flex-col gap-3">
                <div>
                    <p id="demographic-languages-label"
                        class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                        Languages
                    </p>
                    <p id="demographic-languages-hint" class="text-xs text-gray-500 dark:text-gray-400">Search the TikTok
                        language list and tick codes to restrict delivery. Leave none selected so TikTok targets all
                        languages.</p>
                </div>
                @if (createSparkCampaignService.languages().length === 0) {
                <p class="rounded-md border border-primary/35 bg-primary/10 px-3 py-2 text-sm font-medium text-accent dark:border-primary/35 dark:bg-primary/25"
                    role="status">
                    All languages — no language restriction is applied.
                </p>
                }
                @if (createSparkCampaignService.adGroupLanguageOptions() === undefined) {
                <p class="text-sm text-gray-500 dark:text-gray-400" role="status">Loading languages…</p>
                } @else if ((createSparkCampaignService.adGroupLanguageOptions() ?? []).length === 0) {
                <p class="text-sm text-gray-500 dark:text-gray-400" role="status">No languages returned for this
                    advertiser. You can still leave the list empty to target all languages.</p>
                } @else {
                <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
                    <div class="flex flex-col gap-2">
                        <div class="relative">
                            <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-4 text-gray-400" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                        d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                            <input type="search" id="demographic-language-search"
                                class="block w-full rounded-md border-0 bg-white py-2 pl-10 pr-3 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary dark:bg-white/5 dark:text-white dark:ring-white/10 dark:placeholder:text-gray-500 dark:focus:ring-primary"
                                placeholder="Search by language name or code" autocomplete="off"
                                [value]="languageSearchQuery()" (input)="onLanguageSearchInput($event)"
                                aria-labelledby="demographic-languages-label"
                                aria-describedby="demographic-languages-hint" />
                        </div>
                        <div class="max-h-60 overflow-y-auto rounded-lg bg-white py-1 shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-900/40 dark:ring-white/10"
                            role="group" aria-labelledby="demographic-languages-label">
                            @if (filteredLanguageOptions().length === 0) {
                            <p class="px-3 py-4 text-sm text-gray-500 dark:text-gray-400" role="status">No languages
                                match your search.</p>
                            } @else {
                            @for (opt of filteredLanguageOptions(); track trackLanguageOption($index, opt)) {
                            <div [class]="languageRowClass(opt.code)">
                                <input type="checkbox" [id]="'demographic-lang-' + opt.code"
                                    [checked]="isLanguageSelected(opt.code)"
                                    (change)="onLanguageCheckboxChange(opt.code, $event)"
                                    class="h-4 w-4 shrink-0 rounded border-gray-300 accent-primary focus:ring-primary dark:border-white/20 dark:accent-primary dark:focus:ring-primary" />
                                <label [for]="'demographic-lang-' + opt.code"
                                    class="block min-w-0 flex-1 cursor-pointer truncate text-sm font-medium text-gray-900 dark:text-gray-100">
                                    {{ opt.name }}
                                </label>
                                <span class="shrink-0 font-mono text-xs text-gray-500 dark:text-gray-400">{{ opt.code
                                    }}</span>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    <div
                        class="rounded-lg border border-primary/35 bg-gray-50/80 p-3 shadow-sm dark:border-primary/35 dark:bg-white/5">
                        <div class="flex items-start justify-between gap-2">
                            <p class="text-sm font-semibold text-gray-900 dark:text-white">Selected language codes</p>
                            <button type="button"
                                class="rounded p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:hover:bg-white/10 dark:hover:text-white"
                                (click)="clearAllLanguageSelections()"
                                [attr.aria-label]="'Clear all selected languages'"
                                [disabled]="createSparkCampaignService.languages().length === 0">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5" aria-hidden="true">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                        </div>
                        @if (createSparkCampaignService.languages().length === 0) {
                        <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">None selected — all languages.</p>
                        } @else {
                        <div class="mt-3 flex flex-wrap gap-2">
                            @for (code of selectedLanguageCodesSorted(); track code) {
                            <span
                                class="inline-flex max-w-full items-center gap-1 rounded-md bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm ring-1 ring-gray-200/90 dark:bg-white/10 dark:text-gray-200 dark:ring-white/15">
                                <span class="min-w-0 truncate">{{ createSparkCampaignService.languageLabelsByCode().get(code)
                                    ?? code }}</span>
                                <span class="shrink-0 font-mono text-[10px] text-gray-400 dark:text-gray-500">{{ code
                                    }}</span>
                                <button type="button"
                                    class="shrink-0 rounded p-0.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-white/10 dark:hover:text-white"
                                    (click)="removeLanguageCode(code)"
                                    [attr.aria-label]="'Remove language ' + code">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-3.5" aria-hidden="true">
                                        <path
                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                    </svg>
                                </button>
                            </span>
                            }
                        </div>
                        }
                    </div>
                </div>
                }
            </div>

            @if (showHfssSection()) {
            <div class="sm:col-span-3 flex flex-row items-start gap-x-3">
                <div class="flex h-6 shrink-0 items-center">
                    <div class="group grid size-4 grid-cols-1">
                        <input id="hfss-product-checkbox" type="checkbox" name="hfssProduct"
                            aria-describedby="hfss-description" [formControl]="hfssControl"
                            class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-primary dark:checked:bg-primary dark:indeterminate:border-primary dark:indeterminate:bg-primary dark:focus-visible:outline-primary dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                            class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                            <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="opacity-0 group-has-checked:opacity-100" />
                            <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                    </div>
                </div>
                <div class="">
                    <label for="hfss-product-checkbox"
                        class="block text-sm/6 font-medium text-gray-900 dark:text-white">HFSS
                        Product/Brand</label>
                    <p id="hfss-description" class="text-xs text-gray-500 dark:text-gray-400">Check this if you
                        are
                        promoting or prominently featuring a product or brand classed as high in fat, salt or
                        sugar.
                    </p>
                </div>
            </div>
            }
        </div>
    </div>
    }
    <!-- Opened Content - END -->
</div>